/* eslint-disable  */
import React, { useEffect, useState } from 'react'
import AwsConfig from '../../Config/AwsConfig'
// import { Font_radiobtn, Font_radiobtn2, Font_radiobtn3, Font_radiobtn4, Font_radiobtn5, Font_radiobtn6 } from "./font_radiobtn";
import PreviewShareImage from './PreviewShareImage'
// import 'quill/dist/quill.snow.css'; // Add css for snow theme
import Editor from '../../Editor'
// import Template7 from './Template7';
export default function TextBlocks(props) {
  const [multimage, setmultiimage] = useState()
  const [selectedImages, setSelectedImages] = useState([])
  const [render, setrender] = useState(false)
  const { selectedTheme, contentData } = props
  // take the vaplue of content data from props adnd set values to ttitle ,description and image
  const { noOfTextBlocks } = selectedTheme
  const [title, setTitle] = useState('')
  const [no_ofSelectedimagesT_F, setNo_ofSelectedimagesT_F] = useState(true)
  const [socialMediaDes, setSocialMediaDes] = useState('')
  const [image, setImage] = useState('')
  const [description, setDescription] = useState('')
  const [description2, setDescription2] = useState('')
  const [description3, setDescription3] = useState('')
  const [imageborderbool, setimageborderbool] = useState(false)
  const styles = {
    input: {
      width: '100%',
      height: '120px',
    },
  }

  const [color1, setColor1] = useState('white')
  function yellowColor(event) {
    if (event.target.value === 'yellow') {
      setColor1('yellow')
    }
  }

  function whiteColor() {
    setColor1('white')
  }

  function loadimg1(e) {
    setImage(e.target.files[0])
    const url1 = URL.createObjectURL(e.target.files[0])
    setImage(url1)
  }

  console.log(image, 'imageegami')
  const getContenttitle = item => {
    let thumbnailTitle = ''

    const { storyDetails } = item.contentMetaInfo
    let lang = 'En'
    if (item.contentLanguages) {
      lang = item.contentLanguages.includes('En') ? 'En' : 'Te'
    }

    thumbnailTitle = storyDetails && storyDetails[`storyTitle_${lang}`]

    return thumbnailTitle
  }

  const [multimage12, setmultimage12] = useState()
  const getContentDescription = item => {
    let thumbnailTitle = ''

    const { storyDetails } = item.contentMetaInfo
    let lang = 'En'
    if (item.contentLanguages) {
      lang = item.contentLanguages.includes('En') ? 'En' : 'Te'
    }

    thumbnailTitle = storyDetails && storyDetails[`storyCardDescription_${lang}`]

    return thumbnailTitle
  }

  useEffect(() => {
    const getTitleAndDescription = async () => {
      const imageSrc = getImageUri(contentData)
      console.log(imageSrc, 'imageSrc=============================')
      const title = getContenttitle(contentData)
      setTitle(title)
      const description = getContentDescription(contentData)
      setDescription(description)

      const socialMediaDes = title + description
      setSocialMediaDes(socialMediaDes)
      setrender(true)
    }

    if (contentData && Object.keys(contentData).length > 0) {
      getTitleAndDescription()
    } // run it, run it
  }, [selectedTheme, contentData]) // useEffect end
  function handleTitleName(value) {
    setTitle(value)
  }

  function handleSocialMediaDescription(value) {
    setSocialMediaDes(value)
  }

  const [mimages, setmimages] = useState([])
  const getImageUri = item => {
    const { storyDetails, thumbnailURL } = item.contentMetaInfo
    console.log(
      storyDetails.storyCardImages,
      'storyDetails.storyCardImages========================',
    )
    const arrayimage123 = storyDetails.storyCardImages
    setmultiimage(arrayimage123)
    setmimages(arrayimage123)
    console.log(multimage, 'multimage123321')
    const cdnurl = AwsConfig.cdn_url
    const images = []
    storyDetails.storyCardImages.map(imageitem => {
      let imagesrc = ''
      if (imageitem && !imageitem.image.includes(cdnurl)) {
        imagesrc = cdnurl + imageitem
      }

      if (imageitem === undefined && storyDetails && storyDetails.youtubeID !== '') {
        imagesrc = `https://img.youtube.com/vi/${storyDetails.youtubeID}/default.jpg`
      }

      if (!imageitem && thumbnailURL) {
        imagesrc = thumbnailURL
        if (imageitem && !imageitem.image.includes(cdnurl)) {
          imagesrc = cdnurl + thumbnailURL
        }
      }

      images.push(imagesrc)
      console.log(imagesrc, 'imagesrc=======')
      console.log(images, 'imagesimages')
      return images
    })
  }

  const list = []
  for (let index = 0; index < noOfTextBlocks; index++) {
    list.push(<li>{index}</li>)
  }
  // const [disableInput, setdisableInput] = useState(true)
  // const [disableInput, setdisableInput] = useState(true)
  // function DisableTitleAndDisc() {
  // 	setdisableInput(!disableInput)
  // }

  const [disableTandD, setDisableTandD] = useState(true)
  const [disableCount, setDisableCount] = useState(2)
  function DisableTitleAndDisc() {
    setDisableCount(disableCount + 1)
    if (disableCount % 2 === 0) {
      setDisableTandD(false)
    } else {
      setDisableTandD(true)
    }
  }

  let defval

  // const[selectedImagesArrayprop,setselectedImagesArrayprop]=useState()
  function checkselectImage(imageToPush) {
    console.log(imageToPush, 'imageToPush=============')
    const selectedImagesArray = [...selectedImages]
    const selectedImageIndex = selectedImagesArray.findIndex(
      item => item && item.image == imageToPush.image,
    )

    if (selectedImageIndex > -1) {
      selectedImagesArray.filter(item => item !== undefined)
      selectedImagesArray.splice(selectedImageIndex, 1)
    } else {
      selectedImagesArray.push(imageToPush)
    }

    console.log(selectedImagesArray, 'imagesselectedImagesArrayryyyyyyyyyy')
    console.log(selectedImagesArray, 'imagesselectedImagesArrayryyyyyyyyyy after')

    setSelectedImages(selectedImagesArray)

    if (selectedImagesArray.length > 4) {
      setNo_ofSelectedimagesT_F(false)
    }

    if (selectedImagesArray.length <= 4) {
      setNo_ofSelectedimagesT_F(true)
    }

    console.log(no_ofSelectedimagesT_F, 'no_ofSelectedimagesT_F')
  }

  const [defaultimg, setdefaultimg] = useState()
  defval = image

  console.log(multimage, '96769')
  const renderTextBlock = count => {
    switch (count) {
      case 11:
        return (
          <div className='col-md-6 renderTextBlock'>
            <div>
              <input type='checkbox' defaultChecked name='radio' onClick={DisableTitleAndDisc} />
              <label>Use Template</label>
            </div>
            <label>Title</label>
            {disableTandD ? (
              <div>
                <Editor setdescvalue={setTitle} descvalue={title} />
              </div>
            ) : (
              <div style={{ pointerEvents: 'none' }}>
                <Editor setdescvalue={setTitle} descvalue={title} />
              </div>
            )}
            <div>
              <div>
                <p>choose text color</p>
                <div>
                  <label>yellow</label>
                  <input type='radio' onClick={yellowColor} name='color' value='yellow' />
                </div>
                <div>
                  <label>white</label>
                  <input type='radio' onClick={whiteColor} name='color' value='white' />
                </div>
              </div>
            </div>
            <label>Description For Social Media Post</label>
            <div>
              <textarea
                style={styles.input}
                type='text'
                onChange={e => {
                  handleSocialMediaDescription(e.target.value)
                }}
                value={socialMediaDes}
                placeholder='Please Enter Title'
              ></textarea>
              <text style={{ fontWeight: 'bold' }}>Count: {socialMediaDes?.length}/256</text>
            </div>
            {socialMediaDes?.length > 256 && (
              <text style={{ color: 'red' }}>
                Maximum allowed characteres in Twitter post is 256
              </text>
            )}
            <div className='naddbtn'>
              <input type='file' className='ninpfile' onChange={loadimg1} />
            </div>
            <div>
              <label>Images</label>
              {/* <img
								className='contentImageStyle'
								src={defaultimg ? image : multimage[0].image} alt="alternatetext"></img> */}

              {console.log(defval, 'multimage[0].image')}
              <div className='d-flex flex-wrap'>
                {multimage.map((item11, index) => {
                  const checkImageIsChecked = selectedImages.findIndex(
                    imageitem => imageitem && imageitem.image == item11.image,
                  )
                  console.log('1267268')
                  function selectImage(item11) {
                    setmultimage12(defval)
                    setdefaultimg(true)
                    console.log(item11.image, 'Selectedimage')
                    setImage(item11.image)
                    setimageborderbool({
                      isSelected: true,
                      selectedIndex: index,
                    })
                  }

                  return (
                    <div className='d-flex justify-content-center align-items-center flex-column m-2'>
                      <div className='d-flex justify-content-center align-items-center'>
                        <img
                          key={index}
                          type='button'
                          onClick={() => selectImage(item11)}
                          className='contentImageStyle'
                          src={item11.image}
                          style={{
                            border:
                              imageborderbool.isSelected && imageborderbool.selectedIndex == index
                                ? '2px solid red'
                                : 'none',
                            curser: 'pointer',
                            width: '100px',
                            height: '100px',
                            gap: '10px',
                          }}
                          alt='alternatetext'
                        ></img>
                      </div>
                      <div className='d-flex justify-content-center align-items-center'>
                        <input
                          type='checkbox'
                          checked={checkImageIsChecked > -1}
                          onClick={() => checkselectImage(item11)}
                        />
                        <text>Post</text>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            {!no_ofSelectedimagesT_F ? (
              <p style={{ color: 'red' }}> max 4 images can be post</p>
            ) : (
              ''
            )}
          </div>
        )
        break
      case 1:
        return (
          <div className='col-md-6 renderTextBlock'>
            <label>Title</label>
            <div>
              <textarea
                style={styles.input}
                type='text'
                onChange={e => {
                  handleTitleName(e.target.value)
                }}
                value={title}
                placeholder='Please Enter Title'
              ></textarea>
            </div>
            {/* <Font_radiobtn fontSizedefault={fontSizedefault} fontSize={fontSize} fontSize1={fontSize1} fontSize2={fontSize2} /> */}

            <label>Description For Social Media Post</label>
            <div>
              <textarea
                style={styles.input}
                type='text'
                onChange={e => {
                  handleSocialMediaDescription(e.target.value)
                }}
                value={socialMediaDes}
                placeholder='Please Enter Title'
              ></textarea>
              <text style={{ fontWeight: 'bold' }}>Count: {socialMediaDes?.length}/256</text>
            </div>
            {socialMediaDes?.length > 256 && (
              <text style={{ color: 'red' }}>
                Maximum allowed characteres in Twitter post is 256
              </text>
            )}
            <div className='naddbtn'>
              <input type='file' className='ninpfile' onChange={loadimg1} />
            </div>
            <div>
              <label>Images</label>
              {/* <img
								className='contentImageStyle'
								src={contentData ? image : ''} alt="alternatetext"></img> */}
            </div>
            {!no_ofSelectedimagesT_F ? (
              <p style={{ color: 'red' }}> max 4 images can be post</p>
            ) : (
              ''
            )}
          </div>
        )
        break

      case 2:
        return (
          <div className='col-md-6 renderTextBlock'>
            <div>
              <input type='checkbox' defaultChecked name='radio' onClick={DisableTitleAndDisc} />
              <label>Use Template</label>
            </div>
            <label>Title</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setTitle} descvalue={title} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setTitle} descvalue={title} />
                </div>
              )}
            </div>
            <label>Description 1</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setDescription} descvalue={description} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setTitle} descvalue={description} />
                </div>
              )}
            </div>
            <label>Description 2</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setDescription2} descvalue={description2} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setDescription2} descvalue={description2} />
                </div>
              )}
            </div>

            <label>Description For Social Media Post</label>
            <div>
              <textarea
                style={styles.input}
                type='text'
                onChange={e => {
                  handleSocialMediaDescription(e.target.value)
                }}
                value={socialMediaDes}
                placeholder='Please Enter Title'
              ></textarea>
              <text style={{ fontWeight: 'bold' }}>Count: {socialMediaDes?.length}/256</text>
            </div>
            {socialMediaDes?.length > 256 && (
              <text style={{ color: 'red' }}>
                Maximum allowed characteres in Twitter post is 256
              </text>
            )}
            <div>
              <div className='naddbtn'>
                <input type='file' className='ninpfile' onChange={loadimg1} />
              </div>
            </div>

            <div>
              <label>Images</label>
              {/* <img
							className='contentImageStyle'
							src={defaultimg ? image : multimage[0].image} alt="alternatetext"></img> */}
            </div>
            {console.log(selectedImages, 'selectedImages=-===============')}

            <div className='d-flex flex-wrap'>
              {multimage.map((item11, index) => {
                const checkImageIsChecked = selectedImages.findIndex(
                  imageitem => imageitem && imageitem.image == item11.image,
                )

                console.log('1267268')
                function selectImage(item11) {
                  setdefaultimg(true)
                  console.log('Selectedimage')
                  setImage(item11.image)
                  setimageborderbool({
                    isSelected: true,
                    selectedIndex: index,
                  })
                }

                return (
                  <div className='d-flex justify-content-center align-items-center flex-column m-2'>
                    <div className='d-flex justify-content-center align-items-center'>
                      <img
                        key={index}
                        type='button'
                        onClick={() => selectImage(item11)}
                        className='contentImageStyle'
                        src={item11.image}
                        style={{
                          border:
                            imageborderbool.isSelected && imageborderbool.selectedIndex == index
                              ? '2px solid red'
                              : 'none',
                          curser: 'pointer',
                          width: '100px',
                          height: '100px',
                          gap: '10px',
                        }}
                        alt='alternatetext'
                      ></img>
                    </div>
                    <div className='d-flex justify-content-center align-items-center'>
                      <input
                        type='checkbox'
                        checked={checkImageIsChecked > -1}
                        onClick={() => checkselectImage(item11)}
                      />
                      <text>Post</text>
                    </div>
                  </div>
                )
              })}
            </div>
            {!no_ofSelectedimagesT_F ? (
              <p style={{ color: 'red' }}> max 4 images can be post</p>
            ) : (
              ''
            )}
          </div>
        )
        break
      case 3:
        return (
          <div className='col-md-6 renderTextBlock'>
            <div>
              <input type='checkbox' defaultChecked name='radio' onClick={DisableTitleAndDisc} />
              <label>Use Template</label>
            </div>
            <label>Title</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setTitle} descvalue={title} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setTitle} descvalue={title} />
                </div>
              )}
            </div>
            <label>Description 1</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setDescription} descvalue={description} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setDescription} descvalue={description} />
                </div>
              )}
            </div>
            <label>Description 2</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setDescription2} descvalue={description2} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setDescription2} descvalue={description2} />
                </div>
              )}
            </div>
            <label>Description 3</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setDescription3} descvalue={description3} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setDescription3} descvalue={description3} />
                </div>
              )}
            </div>

            <label>Description For Social Media Post</label>
            <div>
              <textarea
                style={styles.input}
                type='text'
                onChange={e => {
                  handleSocialMediaDescription(e.target.value)
                }}
                value={socialMediaDes}
                placeholder='Please Enter Title'
              ></textarea>
              <text style={{ fontWeight: 'bold' }}>Count: {socialMediaDes?.length}/256</text>
            </div>
            {socialMediaDes?.length > 256 && (
              <text style={{ color: 'red' }}>
                Maximum allowed characteres in Twitter post is 256
              </text>
            )}
            <div className='naddbtn'>
              <input type='file' className='ninpfile' onChange={loadimg1} />
            </div>
            <div>
              <label>Images</label>
              {/* <img
							className='contentImageStyle'
							src={defaultimg ? image : multimage[0].image} alt="alternatetext"></img> */}
            </div>
            {console.log(selectedImages, 'selectedImages=-===============')}

            <div className='d-flex flex-wrap'>
              {multimage.map((item11, index) => {
                const checkImageIsChecked = selectedImages.findIndex(
                  imageitem => imageitem && imageitem == item11.image,
                )

                console.log('1267268')
                function selectImage(item11) {
                  setdefaultimg(true)
                  console.log('Selectedimage')
                  setImage(item11.image)
                  setimageborderbool({
                    isSelected: true,
                    selectedIndex: index,
                  })
                }

                return (
                  <div className='d-flex justify-content-center align-items-center flex-column m-2'>
                    <div className='d-flex justify-content-center align-items-center'>
                      <img
                        key={index}
                        type='button'
                        onClick={() => selectImage(item11)}
                        className='contentImageStyle'
                        src={item11.image}
                        style={{
                          border:
                            imageborderbool.isSelected && imageborderbool.selectedIndex == index
                              ? '2px solid red'
                              : 'none',
                          curser: 'pointer',
                          width: '100px',
                          height: '100px',
                          gap: '10px',
                        }}
                        alt='alternatetext'
                      ></img>
                    </div>
                    <div className='d-flex justify-content-center align-items-center'>
                      <input
                        type='checkbox'
                        checked={checkImageIsChecked > -1}
                        onClick={() => checkselectImage(item11)}
                      />
                      <text>Post</text>
                    </div>
                  </div>
                )
              })}
            </div>
            {!no_ofSelectedimagesT_F ? (
              <p style={{ color: 'red' }}> max 4 images can be post</p>
            ) : (
              ''
            )}
          </div>
        )
        break
      case 4:
        return (
          <div className='col-md-6 renderTextBlock'>
            <div>
              <input type='checkbox' defaultChecked name='radio' onClick={DisableTitleAndDisc} />
              <label>Use Template</label>
            </div>
            <label>Title</label>
            {/* <div curser="true"> */}

            {disableTandD ? (
              <div>
                <Editor setdescvalue={setTitle} descvalue={title} />
              </div>
            ) : (
              <div style={{ pointerEvents: 'none' }}>
                <Editor setdescvalue={setTitle} descvalue={title} />
              </div>
            )}
            <label>Description 1</label>
            {/* <div> */}
            {disableTandD ? (
              <div>
                <Editor setdescvalue={setDescription} descvalue={description} />
              </div>
            ) : (
              <div style={{ pointerEvents: 'none' }}>
                <Editor setdescvalue={setDescription} descvalue={description} />
              </div>
            )}

            <label>Description For Social Media Post</label>
            <div>
              <textarea
                style={styles.input}
                type='text'
                onChange={e => {
                  handleSocialMediaDescription(e.target.value)
                }}
                value={socialMediaDes}
                placeholder='Please Enter Title'
              ></textarea>
              <text style={{ fontWeight: 'bold' }}>Count: {socialMediaDes?.length}/256</text>
            </div>
            {socialMediaDes?.length > 256 && (
              <text style={{ color: 'red' }}>
                Maximum allowed characteres in Twitter post is 256
              </text>
            )}
            <div>
              <div className='naddbtn'>
                <input type='file' className='ninpfile' onChange={loadimg1} />
              </div>
            </div>

            <div>
              <label>Images</label>
              {/* <img
							className='contentImageStyle'
							src={defaultimg ? image : multimage[0].image} alt="alternatetext"></img> */}
            </div>
            <div className='d-flex flex-wrap'>
              {multimage.map((item11, index) => {
                const checkImageIsChecked = selectedImages.findIndex(
                  imageitem => imageitem && imageitem.image == item11.image,
                )

                console.log('1267268')
                function selectImage(item11) {
                  setdefaultimg(true)
                  console.log('Selectedimage')
                  setImage(item11.image)
                  setimageborderbool({
                    isSelected: true,
                    selectedIndex: index,
                  })
                }

                return (
                  <div className='d-flex justify-content-center align-items-center flex-column m-2'>
                    <div className='d-flex justify-content-center align-items-center'>
                      <img
                        key={index}
                        type='button'
                        onClick={() => selectImage(item11)}
                        className='contentImageStyle'
                        src={item11.image}
                        style={{
                          border:
                            imageborderbool.isSelected && imageborderbool.selectedIndex == index
                              ? '2px solid red'
                              : 'none',
                          curser: 'pointer',
                          width: '100px',
                          height: '100px',
                          gap: '10px',
                        }}
                        alt='alternatetext'
                      ></img>
                    </div>
                    <div className='d-flex justify-content-center align-items-center'>
                      <input
                        type='checkbox'
                        checked={checkImageIsChecked > -1}
                        onClick={() => checkselectImage(item11)}
                      />
                      <text>Post</text>
                    </div>
                  </div>
                )
              })}
            </div>
            {!no_ofSelectedimagesT_F ? (
              <p style={{ color: 'red' }}> max 4 images can be post</p>
            ) : (
              ''
            )}
          </div>
        )
        break
      case 5:
        return (
          <div className='col-md-6 renderTextBlock'>
            <div>
              <input type='checkbox' defaultChecked name='radio' onClick={DisableTitleAndDisc} />
              <label>Use Template</label>
            </div>
            <label>Title</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setTitle} descvalue={title} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setTitle} descvalue={title} />
                </div>
              )}
            </div>

            <label>Description For Social Media Post</label>
            <div>
              <textarea
                style={styles.input}
                type='text'
                onChange={e => {
                  handleSocialMediaDescription(e.target.value)
                }}
                value={socialMediaDes}
                placeholder='Please Enter Title'
              ></textarea>
              <text style={{ fontWeight: 'bold' }}>Count: {socialMediaDes?.length}/256</text>
            </div>
            {socialMediaDes?.length > 256 && (
              <text style={{ color: 'red' }}>
                Maximum allowed characteres in Twitter post is 256
              </text>
            )}
            <div>
              <div className='naddbtn'>
                <input type='file' className='ninpfile' onChange={loadimg1} />
              </div>
            </div>

            <div>
              <label>Images</label>
              {/* <img
							className='contentImageStyle'
							src={defaultimg ? image : multimage[0].image} alt="alternatetext"></img> */}
            </div>
            <div className='d-flex flex-wrap'>
              {multimage.map((item11, index) => {
                const checkImageIsChecked = selectedImages.findIndex(
                  imageitem => imageitem && imageitem.image == item11.image,
                )

                console.log('1267268')
                function selectImage(item11) {
                  setdefaultimg(true)
                  console.log('Selectedimage')
                  setImage(item11.image)
                  setimageborderbool({
                    isSelected: true,
                    selectedIndex: index,
                  })
                }

                return (
                  <div className='d-flex justify-content-center align-items-center flex-column m-2'>
                    <div className='d-flex justify-content-center align-items-center'>
                      <img
                        key={index}
                        type='button'
                        onClick={() => selectImage(item11)}
                        className='contentImageStyle'
                        src={item11.image}
                        style={{
                          border:
                            imageborderbool.isSelected && imageborderbool.selectedIndex == index
                              ? '2px solid red'
                              : 'none',
                          curser: 'pointer',
                          width: '100px',
                          height: '100px',
                          gap: '10px',
                        }}
                        alt='alternatetext'
                      ></img>
                    </div>
                    <div className='d-flex justify-content-center align-items-center'>
                      <input
                        type='checkbox'
                        checked={checkImageIsChecked > -1}
                        onClick={() => checkselectImage(item11)}
                      />
                      <text>Post</text>
                    </div>
                  </div>
                )
              })}
            </div>
            {!no_ofSelectedimagesT_F ? (
              <p style={{ color: 'red' }}> max 4 images can be post</p>
            ) : (
              ''
            )}
          </div>
        )
        break
      case 6:
        return (
          <div className='col-md-6 renderTextBlock'>
            <div>
              <input type='checkbox' name='radio' defaultChecked onClick={DisableTitleAndDisc} />
              <label>Use Template</label>
            </div>
            <label>Title</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setTitle} descvalue={title} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setTitle} descvalue={title} />
                </div>
              )}
            </div>

            <label>Description 1</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setDescription} descvalue={description} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setDescription} descvalue={description} />
                </div>
              )}
            </div>
            <label>Description 2</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setDescription2} descvalue={description2} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setDescription2} descvalue={description2} />
                </div>
              )}
            </div>
            <label>Description 3</label>
            <div>
              {disableTandD ? (
                <div>
                  <Editor setdescvalue={setDescription3} descvalue={description3} />
                </div>
              ) : (
                <div style={{ pointerEvents: 'none' }}>
                  <Editor setdescvalue={setDescription3} descvalue={description3} />
                </div>
              )}
            </div>

            <label>Description For Social Media Post</label>
            <div>
              <textarea
                style={styles.input}
                type='text'
                onChange={e => {
                  handleSocialMediaDescription(e.target.value)
                }}
                value={socialMediaDes}
                placeholder='Please Enter Title'
              ></textarea>
              <text style={{ fontWeight: 'bold' }}>Count: {socialMediaDes?.length}/256</text>
            </div>
            {socialMediaDes?.length > 256 && (
              <text style={{ color: 'red' }}>
                Maximum allowed characteres in Twitter post is 256
              </text>
            )}
            <div className='naddbtn'>
              <input type='file' className='ninpfile' onChange={loadimg1} />
            </div>
            <div>
              <label>Images</label>
              {/* <img
							className='contentImageStyle'
							src={defaultimg ? image : multimage[0].image} alt="alternatetext"></img> */}
            </div>
            <div className='d-flex flex-wrap'>
              {multimage.map((item11, index) => {
                const checkImageIsChecked = selectedImages.findIndex(
                  imageitem => imageitem && imageitem.image == item11.image,
                )

                console.log('1267268')
                function selectImage(item11) {
                  setdefaultimg(true)
                  console.log('Selectedimage')
                  setImage(item11.image)
                  setimageborderbool({
                    isSelected: true,
                    selectedIndex: index,
                  })
                }

                return (
                  <div className='d-flex justify-content-center align-items-center flex-column m-2'>
                    <div className='d-flex justify-content-center align-items-center'>
                      <img
                        key={index}
                        type='button'
                        onClick={() => selectImage(item11)}
                        className='contentImageStyle'
                        src={item11.image}
                        style={{
                          border:
                            imageborderbool.isSelected && imageborderbool.selectedIndex == index
                              ? '2px solid red'
                              : 'none',
                          curser: 'pointer',
                          width: '100px',
                          height: '100px',
                          gap: '10px',
                        }}
                        alt='alternatetext'
                      ></img>
                    </div>
                    <div className='d-flex justify-content-center align-items-center'>
                      <input
                        type='checkbox'
                        checked={checkImageIsChecked > -1}
                        onClick={() => checkselectImage(item11)}
                      />
                      <text>Post</text>
                    </div>
                  </div>
                )
              })}
            </div>
            {!no_ofSelectedimagesT_F ? (
              <p style={{ color: 'red' }}> max 4 images can be post</p>
            ) : (
              ''
            )}
          </div>
        )
        break

      default:
        return (
          <div className='col-md-6 renderTextBlock'>
            <label>Title</label>
            <div>
              <textarea
                style={styles.input}
                type='text'
                onChange={e => {
                  handleTitleName(e.target.value)
                }}
                value={title}
                placeholder='Please Enter Title'
              ></textarea>
            </div>
            <label>Images</label>
            {/* <img
							className='contentImageStyle'
							src={contentData ? image : ''} alt="alternatetext"></img> */}
          </div>
        )
    }
  }

  const data = () => {
    const textarea = {
      title,
      description,
      description2,
      description3,
      socialMediaDes,

      image,
    }
    return textarea
  }

  return (
    <>
      {selectedTheme && Object.keys(selectedTheme).length > 0 && (
        <div className='row'>
          {render && renderTextBlock(selectedTheme.noOfTextBlocks)}
          <div className='col-md-6 preview'>
            <PreviewShareImage
              no_ofSelectedimagesT_F={no_ofSelectedimagesT_F}
              image={image}
              disableTandD={disableTandD}
              selectedImages={selectedImages}
              defaultimg={defaultimg}
              mimages={mimages}
              color1={color1}
              description={description}
              title={title}
              data={data()}
              multimage12={multimage12}
              contentData={contentData}
              defval={defval}
              selectedTheme={selectedTheme}
            />
          </div>
        </div>
      )}
    </>
  )
}
